module.exports = __webpack_public_path__ + "img/ctrl-ising-stub-up--.db6198af.svg";